import { tryCatch } from './tryCatch';
import { isNone } from './typeguards';
export function parseNumber(value) {
  if (isNone(value) || value.trim() === '') {
    return null;
  }
  return tryCatch(() => Number(value)).match(v => v, () => null);
}

/** forces exhaustive checking in a switch statement (you will get a type error if you don't check every case) and throws a traceable error if it ever actually gets called at runtime.
 * Stick it in the default case of a switch statement to make sure you've covered all cases.  */
export function assertNever(val, message) {
  return new Error(`unexpected 'never' case encountered in switch statement over ${message} for value: ${JSON.stringify(val, null, 2)}`);
}
export function noop() {}
export function identity(value) {
  return value;
}
export function none() {
  return null;
}
export function parseJSON(value) {
  return tryCatch(() => JSON.parse(value)).match(v => v, () => null);
}
export function stringify(value) {
  return tryCatch(() => JSON.stringify(value, null, 2)).match(v => v, () => null);
}